/*
 * HdDialog.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-06 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { IconButton, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import React, { ReactElement, useCallback, useState } from 'react'

import { HdCloseIcon } from '../../lib/components/HdIcons'

interface IDialogReturn {
  openDialog: () => void
  dismissDialog: () => void
  isDialogOpen: boolean
  // renderDialog: anya
  renderDialog: ({
    renderBody,
    renderActions,
  }: {
    renderBody: () => ReactElement
    renderActions?: () => ReactElement
  }) => ReactElement
}

export function useHdDialog(title: string, description?: string): IDialogReturn {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

  const openDialog = useCallback(() => {
    setIsDialogOpen(true)
  }, [setIsDialogOpen])
  const dismissDialog = useCallback(() => {
    setIsDialogOpen(false)
  }, [setIsDialogOpen])

  const renderDialog = ({ renderBody, renderActions }) => (
    <Dialog
      aria-label="title"
      open={isDialogOpen}
      onClose={dismissDialog}
      fullWidth={true}
      PaperProps={{ sx: { scroll: 'body', minWidth: '50%' } }}
    >
      <DialogTitle>
        <IconButton
          onClick={dismissDialog}
          sx={{
            position: 'absolute',
            right: '0.25em',
            top: '0.25em',
            color: 'gray',
          }}
        >
          <HdCloseIcon />
        </IconButton>
        <Typography variant="h4" component="h3">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {description ? (
          <DialogContentText sx={{ mb: '1em', fontWeight: 'bold' }}>{description}</DialogContentText>
        ) : null}
        <DialogContentText>{renderBody() || null}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {renderActions ? renderActions(dismissDialog) : <Button onClick={dismissDialog}>Abbrechen</Button>}
      </DialogActions>
    </Dialog>
  )

  return { openDialog, renderDialog, isDialogOpen, dismissDialog }
}
